import React from "react";
import Select from "react-select";
import "./MultiSelect.css";
import { Controller } from "react-hook-form";
import { useTranslation } from 'react-i18next';

const MultiSelectWrapper = ({
  options,
  onChangeForRegion,
  errors,
  name,
  label,
  is_multi,
  mandatory,
  control,
  disabled = false, // Add disabled prop
}) => {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#fff" : "#000",
      backgroundColor: state.isFocused ? "#f0f0f0" : "white",
    }),
    control: (base, state) => ({
      ...base,
      background: "#fcfcfc",
      fontSize: "12px",
      borderColor: state.isFocused
        ? "#000"
        : errors && errors[name]
        ? "#f4694c"
        : "#000",
      boxShadow: "none",
      "&:hover": {
        borderColor:"#000",
      },
      // Apply custom styles if the select is disabled
      ...(disabled && {
        backgroundColor: "#7c8091", // Disabled background color
        color: "#7c8091", // Disabled text color
        cursor: "not-allowed", // Change cursor to indicate it's disabled
        borderColor: "#7c8091", // Light border color when disabled
      }),
      input: (base) => ({
        ...base,
        color: "#000", // Black text while typing
      }),
      singleValue: (base) => ({
        ...base,
        color: "#000", // Black selected text
      }),
      placeholder: (base) => ({
        ...base,
        color: "#000", // Black placeholder text
      }),
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#1a7a73", // Custom colour
    }),
  };

  const { t } = useTranslation();

  return (
    <div id={"container_" + name}>
      <label className="form__label">
        {t(label)} {mandatory && <span className="asterisk">*</span>}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <Select
          styles={customStyles}
          placeholder={t("multiselectplaceholder")}
          classNamePrefix="react-select"
          theme={(theme) => ({
            ...theme,
            borderRadius: 0,
            colors: disabled
              ? {}  // If disabled, set the colors to an empty object
              : {
                  ...theme.colors,
                  primary25: "#1a7a73",
                  neutral50: "#fff",
                  neutral80: "#fff",
                  primary: "black",
                },
          })}
          value={value}
          onChange={(selected) => {
            onChange(selected);
            onChangeForRegion();
          }}
          options={options}
          isMulti={is_multi === false ? false : true}
          isDisabled={disabled} // Set the disabled property
        />
        
        )}
      />
      <p className="error__message">{errors[name]?.message}</p>
    </div>
  );
};

export default MultiSelectWrapper;
